import has from 'lodash/fp/has';

const DEFAULT_LOCALE = 'en-GB';

interface LocaleMap {
    [key: string]: string;
}

const supportedLocaleMap: LocaleMap = {
    'bg-BG': 'bg-BG',
    'cs-CZ': 'cs-CZ',
    'da-DK': 'da-DK',
    'el-GR': 'el-GR',
    'en-GB': 'en-GB',
    'es-ES': 'es-ES',
    'et-EE': 'et-EE',
    'fi-FI': 'fi-FI',
    'fr-FR': 'fr-FR',
    'hr-HR': 'hr-HR',
    'hu-HU': 'hu-HU',
    'it-IT': 'it-IT',
    'ko-KR': 'ko-KR',
    'lt-LT': 'lt-LT',
    'lv-LV': 'lv-LV',
    'nb-NO': 'nb-NO',
    'nl-NL': 'nl-NL',
    'pl-PL': 'pl-PL',
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT',
    'ro-RO': 'ro-RO',
    'sk-SK': 'sk-SK',
    'sl-SI': 'sl-SI',
    'sv-SE': 'sv-SE',
    'de-DE': 'de-DE',

    bg: 'bg-BG',
    cs: 'cs-CZ',
    da: 'da-DK',
    el: 'el-GR',
    en: 'en-GB',
    es: 'es-ES',
    et: 'et-EE',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hr: 'hr-HR',
    hu: 'hu-HU',
    it: 'it-IT',
    ko: 'ko-KR',
    lt: 'lt-LT',
    lv: 'lv-LV',
    nb: 'nb-NO',
    nl: 'nl-NL',
    no: 'nb-NO',
    pl: 'pl-PL',
    pt: 'pt-PT',
    ro: 'ro-RO',
    sk: 'sk-SK',
    sl: 'sl-SI',
    sv: 'sv-SE',
    de: 'de-DE',
};

const extractLanguage = (locale: string | undefined) => (locale ?? DEFAULT_LOCALE).split('-')[0];

const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

const getSupportedLocale = (preferredLocale: string) =>
    has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;

export { DEFAULT_LANG, DEFAULT_LOCALE, extractLanguage, supportedLocaleMap, getSupportedLocale };
